import React from 'react';
import { Divider } from 'antd';
import Column from '../../shared/ui/Column';
import SelectAcceptanceWorkers from '../../controllers/SelectAcceptanceWorkers';
import { fieldNames } from '../../shared/configs/acceptanceForm';
import DateRangeField from '../../controllers/base/DateRangeField';

const { createPickerSetting } = DateRangeField;

const pickerSettings = [
  createPickerSetting({
    name: fieldNames.main.fromDate,
    observableName: fieldNames.main.toDate,
    rules: { required: 'Укажите начальную дату' },
    isFrom: true,
  }),
  createPickerSetting({
    name: fieldNames.main.toDate,
    observableName: fieldNames.main.fromDate,
    rules: { required: 'Укажите конечную дату' },
  }),
];

const MainFieldsCol = () => {
  return (
    <Column title="Основное">
      <DateRangeField pickerSettings={pickerSettings} />
      <Divider style={{ margin: 0 }} />
      <SelectAcceptanceWorkers />
    </Column>
  );
};

export default MainFieldsCol;
